<template>
  <v-container fluid>
    <v-card flat class="my-5 elevation-0" height="100%">
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <v-btn small color="primary" @click="downloadLink(admissionLetter)">
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-row>
        <v-col cols="8" offset="2">
          <v-card-text class="elevation-1 my-1">
            <pdf style="width: 100%" :src="admissionLetter" />
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import pdf from "vue-pdf";
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";

export default {
  name: "AdmissionLetter",
  mixins: [FileMixin],
  components: { pdf },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Application/getAdmissionLetter");
      window.document.title = "KISEB::Admission Letter";
    });
  },
  computed: {
    admissionLetter() {
      return this.$store.getters["Application/appGetters"]("admissionLetter");
    },
  },
};
</script>

<style scoped></style>
